import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const MenuAdvertisement = () => {
    const navigate = useNavigate();
    const slideContainerRef = useRef(null);

    // Add a ref for the wake lock
    const wakeLockRef = useRef(null);

    const [slides, setSlides] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loading, setLoading] = useState(true);
    const [isTransitioning, setIsTransitioning] = useState(false);

    // Add these from second file
    const [showUpdateNotification, setShowUpdateNotification] = useState(false);
    const [apiCallCount, setApiCallCount] = useState(0);
    const [lastApiCall, setLastApiCall] = useState(null);

    // Static Menu Data for Restaurant
    const staticMenuData = [
        // STARTERS
        { dishId: 101, dishName: "Paneer Tikka", price: 250, tag: "Veg", parentId: 1, menuStatus: "Enable", stockQuantity: 50 },
        { dishId: 102, dishName: "Chicken Tikka", price: 320, tag: "Non_Veg", parentId: 1, menuStatus: "Enable", stockQuantity: 40 },
        { dishId: 103, dishName: "Veg Spring Rolls", price: 180, tag: "Veg", parentId: 1, menuStatus: "Enable", stockQuantity: 60 },
        { dishId: 104, dishName: "Fish Fingers", price: 280, tag: "Non_Veg", parentId: 1, menuStatus: "Enable", stockQuantity: 35 },
        { dishId: 105, dishName: "Mushroom Chilly", price: 220, tag: "Veg", parentId: 1, menuStatus: "Enable", stockQuantity: 45 },
        { dishId: 106, dishName: "Chicken Lollipop", price: 290, tag: "Non_Veg", parentId: 1, menuStatus: "Enable", stockQuantity: 55 },
        { dishId: 107, dishName: "Hara Bhara Kabab", price: 200, tag: "Veg", parentId: 1, menuStatus: "Enable", stockQuantity: 40 },
        { dishId: 108, dishName: "Prawns Fry", price: 350, tag: "Non_Veg", parentId: 1, menuStatus: "Enable", stockQuantity: 30 },
        
        // MAIN COURSE
        { dishId: 201, dishName: "Butter Chicken", price: 380, tag: "Non_Veg", parentId: 2, menuStatus: "Enable", stockQuantity: 45 },
        { dishId: 202, dishName: "Paneer Butter Masala", price: 300, tag: "Veg", parentId: 2, menuStatus: "Enable", stockQuantity: 55 },
        { dishId: 203, dishName: "Dal Makhani", price: 220, tag: "Veg", parentId: 2, menuStatus: "Enable", stockQuantity: 70 },
        { dishId: 204, dishName: "Rogan Josh", price: 420, tag: "Non_Veg", parentId: 2, menuStatus: "Enable", stockQuantity: 38 },
        { dishId: 205, dishName: "Palak Paneer", price: 280, tag: "Veg", parentId: 2, menuStatus: "Enable", stockQuantity: 48 },
        { dishId: 206, dishName: "Chicken Chettinad", price: 360, tag: "Non_Veg", parentId: 2, menuStatus: "Enable", stockQuantity: 42 },
        { dishId: 207, dishName: "Veg Kolhapuri", price: 260, tag: "Veg", parentId: 2, menuStatus: "Enable", stockQuantity: 52 },
        { dishId: 208, dishName: "Fish Curry", price: 340, tag: "Non_Veg", parentId: 2, menuStatus: "Enable", stockQuantity: 32 },
        
        // BIRYANI & RICE
        { dishId: 301, dishName: "Hyderabadi Biryani", price: 350, tag: "Non_Veg", parentId: 3, menuStatus: "Enable", stockQuantity: 40 },
        { dishId: 302, dishName: "Veg Biryani", price: 250, tag: "Veg", parentId: 3, menuStatus: "Enable", stockQuantity: 55 },
        { dishId: 303, dishName: "Chicken Fried Rice", price: 280, tag: "Non_Veg", parentId: 3, menuStatus: "Enable", stockQuantity: 48 },
        { dishId: 304, dishName: "Veg Fried Rice", price: 200, tag: "Veg", parentId: 3, menuStatus: "Enable", stockQuantity: 62 },
        { dishId: 305, dishName: "Mushroom Biryani", price: 280, tag: "Veg", parentId: 3, menuStatus: "Enable", stockQuantity: 35 },
        { dishId: 306, dishName: "Mutton Biryani", price: 450, tag: "Non_Veg", parentId: 3, menuStatus: "Enable", stockQuantity: 28 },
        
        // CHINESE
        { dishId: 401, dishName: "Veg Manchurian", price: 220, tag: "Veg", parentId: 4, menuStatus: "Enable", stockQuantity: 65 },
        { dishId: 402, dishName: "Chilli Chicken", price: 290, tag: "Non_Veg", parentId: 4, menuStatus: "Enable", stockQuantity: 52 },
        { dishId: 403, dishName: "Hakka Noodles", price: 210, tag: "Veg", parentId: 4, menuStatus: "Enable", stockQuantity: 58 },
        { dishId: 404, dishName: "Schezwan Noodles", price: 230, tag: "Veg", parentId: 4, menuStatus: "Enable", stockQuantity: 45 },
        { dishId: 405, dishName: "Chicken Noodles", price: 260, tag: "Non_Veg", parentId: 4, menuStatus: "Enable", stockQuantity: 48 },
        { dishId: 406, dishName: "Gobi Manchurian", price: 200, tag: "Veg", parentId: 4, menuStatus: "Enable", stockQuantity: 55 },
        
        // BREADS
        { dishId: 501, dishName: "Butter Naan", price: 40, tag: "Veg", parentId: 5, menuStatus: "Enable", stockQuantity: 150 },
        { dishId: 502, dishName: "Garlic Naan", price: 50, tag: "Veg", parentId: 5, menuStatus: "Enable", stockQuantity: 140 },
        { dishId: 503, dishName: "Tandoori Roti", price: 25, tag: "Veg", parentId: 5, menuStatus: "Enable", stockQuantity: 200 },
        { dishId: 504, dishName: "Lachha Paratha", price: 45, tag: "Veg", parentId: 5, menuStatus: "Enable", stockQuantity: 120 },
        { dishId: 505, dishName: "Stuffed Kulcha", price: 60, tag: "Veg", parentId: 5, menuStatus: "Enable", stockQuantity: 90 },
        
        // BEVERAGES
        { dishId: 601, dishName: "Masala Chai", price: 20, tag: "Veg", parentId: 6, menuStatus: "Enable", stockQuantity: 200 },
        { dishId: 602, dishName: "Cold Coffee", price: 80, tag: "Veg", parentId: 6, menuStatus: "Enable", stockQuantity: 85 },
        { dishId: 603, dishName: "Fresh Lime Soda", price: 60, tag: "Veg", parentId: 6, menuStatus: "Enable", stockQuantity: 95 },
        { dishId: 604, dishName: "Butter Milk", price: 40, tag: "Veg", parentId: 6, menuStatus: "Enable", stockQuantity: 110 },
        { dishId: 605, dishName: "Mango Lassi", price: 90, tag: "Veg", parentId: 6, menuStatus: "Enable", stockQuantity: 75 },
        { dishId: 606, dishName: "Fresh Juice", price: 70, tag: "Veg", parentId: 6, menuStatus: "Enable", stockQuantity: 88 },
        
        // DESSERTS
        { dishId: 701, dishName: "Gulab Jamun", price: 60, tag: "Veg", parentId: 7, menuStatus: "Enable", stockQuantity: 120 },
        { dishId: 702, dishName: "Ras Malai", price: 80, tag: "Veg", parentId: 7, menuStatus: "Enable", stockQuantity: 95 },
        { dishId: 703, dishName: "Ice Cream", price: 70, tag: "Veg", parentId: 7, menuStatus: "Enable", stockQuantity: 150 },
        { dishId: 704, dishName: "Brownie", price: 90, tag: "Veg", parentId: 7, menuStatus: "Enable", stockQuantity: 70 },
        { dishId: 705, dishName: "Kulfi", price: 50, tag: "Veg", parentId: 7, menuStatus: "Enable", stockQuantity: 85 },
        
        // SOUPS
        { dishId: 801, dishName: "Tomato Soup", price: 90, tag: "Veg", parentId: 8, menuStatus: "Enable", stockQuantity: 65 },
        { dishId: 802, dishName: "Hot & Sour Soup", price: 100, tag: "Veg", parentId: 8, menuStatus: "Enable", stockQuantity: 58 },
        { dishId: 803, dishName: "Chicken Soup", price: 120, tag: "Non_Veg", parentId: 8, menuStatus: "Enable", stockQuantity: 52 },
        { dishId: 804, dishName: "Sweet Corn Soup", price: 95, tag: "Veg", parentId: 8, menuStatus: "Enable", stockQuantity: 62 },
        
        // SALADS
        { dishId: 901, dishName: "Green Salad", price: 80, tag: "Veg", parentId: 9, menuStatus: "Enable", stockQuantity: 70 },
        { dishId: 902, dishName: "Chicken Salad", price: 150, tag: "Non_Veg", parentId: 9, menuStatus: "Enable", stockQuantity: 45 },
        { dishId: 903, dishName: "Greek Salad", price: 120, tag: "Veg", parentId: 9, menuStatus: "Enable", stockQuantity: 38 },
        
        // TANDOOR
        { dishId: 1001, dishName: "Tandoori Chicken", price: 280, tag: "Non_Veg", parentId: 10, menuStatus: "Enable", stockQuantity: 48 },
        { dishId: 1002, dishName: "Tandoori Paneer", price: 260, tag: "Veg", parentId: 10, menuStatus: "Enable", stockQuantity: 52 },
        { dishId: 1003, dishName: "Seekh Kabab", price: 240, tag: "Non_Veg", parentId: 10, menuStatus: "Enable", stockQuantity: 42 },
        { dishId: 1004, dishName: "Tandoori Mushroom", price: 220, tag: "Veg", parentId: 10, menuStatus: "Enable", stockQuantity: 38 }
    ];

    // Categories
    const categories = [
        { dishId: 1, dishName: "STARTERS", parentId: 0 },
        { dishId: 2, dishName: "MAIN COURSE", parentId: 0 },
        { dishId: 3, dishName: "BIRYANI & RICE", parentId: 0 },
        { dishId: 4, dishName: "CHINESE", parentId: 0 },
        { dishId: 5, dishName: "BREADS", parentId: 0 },
        { dishId: 6, dishName: "BEVERAGES", parentId: 0 },
        { dishId: 7, dishName: "DESSERTS", parentId: 0 },
        { dishId: 8, dishName: "SOUPS", parentId: 0 },
        { dishId: 9, dishName: "SALADS", parentId: 0 },
        { dishId: 10, dishName: "TANDOOR", parentId: 0 }
    ];

    // FIRST FILE'S EXACT distributeItemsToColumns function (with 18 items per column)
    const distributeItemsToColumns = (items) => {
        const columns = [[], [], []];
        const ITEMS_PER_COLUMN = 18;

        let currentColumn = 0;
        let currentColumnItems = [];

        items.forEach(item => {
            currentColumnItems.push(item);

            if (currentColumnItems.length === ITEMS_PER_COLUMN) {
                columns[currentColumn] = [...currentColumnItems];
                currentColumnItems = [];
                currentColumn = (currentColumn + 1) % 3;
            }
        });

        if (currentColumnItems.length > 0) {
            columns[currentColumn] = [...currentColumnItems];
        }

        for (let i = 0; i < 3; i++) {
            if (!columns[i]) {
                columns[i] = [];
            }
        }

        return columns;
    };

    // ===========================================
    // SCREEN WAKE LOCK MANAGEMENT
    // ===========================================

    // Request screen wake lock
    const requestWakeLock = async () => {
        if ('wakeLock' in navigator) {
            try {
                if (wakeLockRef.current) {
                    await wakeLockRef.current.release();
                }

                //console.log('🔋 Requesting wake lock');
                wakeLockRef.current = await navigator.wakeLock.request('screen');
                //console.log('✅ Screen wake lock acquired');

                wakeLockRef.current.addEventListener('release', () => {
                    //console.log('⚠️ Screen wake lock was released');
                    if (document.visibilityState === 'visible') {
                        requestWakeLock();
                    }
                });

            } catch (err) {
                console.error('❌ Failed to acquire wake lock:', err);
            }
        } else {
            //console.log('❌ Wake Lock API not supported');
        }
    };

    // Release wake lock
    const releaseWakeLock = async () => {
        if (wakeLockRef.current) {
            try {
                await wakeLockRef.current.release();
                wakeLockRef.current = null;
                //console.log('🔓 Screen wake lock released');
            } catch (err) {
                console.error('Error releasing wake lock:', err);
            }
        }
    };

    // ===========================================
    // LOAD STATIC MENU DATA
    // ===========================================
    const loadStaticMenuData = () => {
        //console.log('📋 Loading static menu data');

        const allItems = staticMenuData;
        
        // Get categories (parentId === 0)
        const categoriesList = categories;
        
        // Get dishes that are enabled and have stock
        const dishes = allItems.filter(
            i =>
                i.menuStatus === "Enable" &&
                i.stockQuantity > 0
        );

        let structuredList = [];

        categoriesList.forEach(category => {
            const categoryItems = dishes.filter(
                d => d.parentId === category.dishId
            );

            if (categoryItems.length > 0) {
                structuredList.push({
                    type: "category",
                    name: category.dishName.toUpperCase()
                });

                // Separate Veg and Non-Veg
                const vegItems = categoryItems.filter(item => item.tag === "Veg");
                const nonVegItems = categoryItems.filter(item => item.tag === "Non_Veg");

                vegItems.forEach(item => {
                    structuredList.push({
                        type: "item",
                        dishName: item.dishName.toUpperCase(),
                        price: item.price,
                        dishId: item.dishId,
                        tag: item.tag
                    });
                });

                nonVegItems.forEach(item => {
                    structuredList.push({
                        type: "item",
                        dishName: item.dishName.toUpperCase(),
                        price: item.price,
                        dishId: item.dishId,
                        tag: item.tag
                    });
                });
            }
        });

        // FIRST FILE'S EXACT SLIDE SIZE (54 items)
        const SLIDE_SIZE = 54;
        const generatedSlides = [];

        for (let i = 0; i < structuredList.length; i += SLIDE_SIZE) {
            generatedSlides.push(structuredList.slice(i, i + SLIDE_SIZE));
        }

        setSlides(generatedSlides);
        setLoading(false);
    };

    // ===========================================
    // UPDATE FROM WEBSOCKET (kept for compatibility)
    // ===========================================
    const updateSingleItemInSlides = (updatedDish) => {
        //console.log('🔄 Updating UI for dish:', updatedDish.dishId);

        setSlides(prevSlides => {
            let itemUpdated = false;

            const updatedSlides = prevSlides.map(slide =>
                slide.map(item => {
                    if (item.type === 'item' && item.dishId === updatedDish.dishId) {
                        itemUpdated = true;

                        return {
                            ...item,
                            dishName: updatedDish.dishName?.toUpperCase() || item.dishName,
                            price: updatedDish.price !== undefined ? updatedDish.price : item.price,
                            tag: updatedDish.tag || item.tag,
                            type: 'item'
                        };
                    }
                    return item;
                })
            );

            if (itemUpdated) {
                setShowUpdateNotification(true);
                setTimeout(() => setShowUpdateNotification(false), 1500);
            }

            return updatedSlides;
        });
    };

    // ===========================================
    // INITIALIZATION (removed API call, using static data)
    // ===========================================
    useEffect(() => {
        //console.log('📱 Initializing Menu Advertisement with static data');
        
        // Request wake lock
        requestWakeLock();

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible' && 'wakeLock' in navigator) {
                requestWakeLock();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Load static data
        loadStaticMenuData();

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            releaseWakeLock();
        };
    }, []);

    const goToSlide = (index) => {
        if (isTransitioning || index === currentSlide) return;

        setIsTransitioning(true);
        setCurrentSlide(index);

        setTimeout(() => {
            setIsTransitioning(false);
        }, 500);
    };

    const nextSlide = () => {
        if (slides.length <= 1 || isTransitioning) return;
        const nextIndex = currentSlide === slides.length - 1 ? 0 : currentSlide + 1;
        goToSlide(nextIndex);
    };

    // Auto slide (6 seconds from first file)
    useEffect(() => {
        if (slides.length <= 1) return;

        const interval = setInterval(() => {
            nextSlide();
        }, 6000);

        return () => clearInterval(interval);
    }, [slides, currentSlide, isTransitioning]);

    // FIRST FILE'S EXACT veg/non-veg indicator
    const renderVegNonVegIndicator = (tag) => {
        if (tag === "Veg") {
            return (
                <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "clamp(16px, 2vw, 24px)",
                    height: "clamp(16px, 2vw, 24px)",
                    border: "2px solid #4caf50",
                    borderRadius: "4px",
                    marginRight: "8px",
                    position: "relative",
                    backgroundColor: "#fff",
                    flexShrink: 0
                }}>
                    <span style={{
                        width: "clamp(8px, 1vw, 12px)",
                        height: "clamp(8px, 1vw, 12px)",
                        backgroundColor: "#4caf50",
                        borderRadius: "50%",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)"
                    }} />
                </span>
            );
        } else if (tag === "Non_Veg") {
            return (
                <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "clamp(16px, 2vw, 24px)",
                    height: "clamp(16px, 2vw, 24px)",
                    border: "2px solid #f44336",
                    borderRadius: "4px",
                    marginRight: "8px",
                    position: "relative",
                    backgroundColor: "#fff",
                    flexShrink: 0
                }}>
                    <span style={{
                        width: "clamp(8px, 1vw, 12px)",
                        height: "clamp(8px, 1vw, 12px)",
                        backgroundColor: "#f44336",
                        borderRadius: "50%",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)"
                    }} />
                </span>
            );
        }
        return null;
    };

    if (loading) {
        return (
            <div style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "2rem",
                backgroundColor: "#212529",
                color: "#fff",
                textTransform: "uppercase"
            }}>
                LOADING MENU...
            </div>
        );
    }

    if (slides.length === 0) {
        return (
            <div style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "2rem",
                backgroundColor: "#ee4b2e",
                color: "#fff",
                textTransform: "uppercase"
            }}>
                NO MENU AVAILABLE
            </div>
        );
    }

    const currentSlideData = slides[currentSlide];
    const columns = distributeItemsToColumns(currentSlideData);

    return (
        <div style={{
            height: "100vh",
            background: "#ee4b2e",
            color: "#fff",
            padding: "20px",
            position: "relative",
            overflow: "hidden",
            scrollbarWidth: "none",
            textTransform: "uppercase",
            fontFamily: "Arial, Helvetica, sans-serif"
        }}>
            {/* UPDATE NOTIFICATION (from second file) */}
            {showUpdateNotification && (
                <div style={{
                    position: "fixed",
                    top: "20px",
                    right: "20px",
                    backgroundColor: "#4caf50",
                    color: "white",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    zIndex: 1000,
                    animation: "slideIn 0.3s ease-out"
                }}>
                    Menu Updated!
                </div>
            )}

            {/* BACK BUTTON (from first file) */}
            <div style={{
                position: "absolute",
                top: 22,
                left: 7,
                right: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                zIndex: 10
            }}>
                <button
                    onClick={() => navigate("/Demoordermanagement")}
                    style={{
                        background: "#8b0000",
                        color: "#fff",
                        border: "none",
                        borderRadius: "50%",
                        width: 30,
                        height: 30,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <ArrowBackIcon />
                </button>
            </div>

            {/* 3 COLUMN LAYOUT (EXACTLY from first file) */}
            <div
                ref={slideContainerRef}
                style={{
                    display: "flex",
                    width: "100%",
                    transition: isTransitioning ? "transform 0.5s ease-in-out" : "none",
                    transform: `translateX(-${currentSlide * 100}%)`,
                    marginTop: "0px"
                }}
            >
                {slides.map((slideData, index) => {
                    const columns = distributeItemsToColumns(slideData);

                    return (
                        <div
                            key={index}
                            style={{
                                minWidth: "100%",
                                height: "100%",
                                padding: "0 20px",
                                marginTop: "0px",
                                boxSizing: "border-box"
                            }}
                        >
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gap: "40px",
                                height: "100%",
                                overflow: "hidden"
                            }}>
                                {columns.map((column, colIndex) => (
                                    <div
                                        key={colIndex}
                                        style={{
                                            height: "100%",
                                            overflow: "hidden",
                                            display: "flex",
                                            flexDirection: "column"
                                        }}
                                    >
                                        <div style={{
                                            flex: 1,
                                            overflowY: "hidden",
                                            scrollbarWidth: "none",
                                            msOverflowStyle: "none",
                                            paddingRight: "5px"
                                        }}>
                                            {column.map((item, itemIndex) => {
                                                if (item.type === "category") {
                                                    return (
                                                        <div
                                                            key={`cat-${colIndex}-${itemIndex}`}
                                                            style={{
                                                                fontSize: "2rem",
                                                                fontWeight: "900",
                                                                margin: "0 0 6px 0",
                                                                textAlign: "center",
                                                                color: "#fff",
                                                                letterSpacing: "2px",
                                                                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                                                                borderBottom: "0px solid rgba(255,255,255,0.3)",
                                                                paddingBottom: "4px",
                                                                lineHeight: "1.2"
                                                            }}
                                                        >
                                                            {item.name}
                                                        </div>
                                                    );
                                                }

                                                return (
                                                    <div
                                                        key={item.dishId}
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            fontSize: "clamp(0.9rem, 1.5vw, 1.7rem)",
                                                            padding: "3px 0",
                                                            transition: "all 0.2s ease",
                                                            cursor: "default",
                                                            letterSpacing: "0.5px",
                                                            lineHeight: "1.2"
                                                        }}
                                                    >
                                                        <div style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            flex: 1,
                                                            minWidth: 0
                                                        }}>
                                                            {renderVegNonVegIndicator(item.tag)}

                                                            <span style={{
                                                                fontWeight: "900",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                paddingRight: "15px"
                                                            }}>
                                                                {item.dishName}
                                                            </span>
                                                        </div>

                                                        <span style={{
                                                            fontWeight: "bold",
                                                            color: "rgb(110 255 143)",
                                                            fontSize: "clamp(1rem, 1.6vw, 1.8rem)",
                                                            whiteSpace: "nowrap",
                                                            flexShrink: 0
                                                        }}>
                                                            ₹{item.price}
                                                        </span>
                                                    </div>
                                                );
                                            })}

                                            {column.length < 15 && [...Array(15 - column.length)].map((_, i) => (
                                                <div
                                                    key={`empty-${i}`}
                                                    style={{
                                                        height: "calc((100vh - 230px) / 15)",
                                                        opacity: 0,
                                                        pointerEvents: "none"
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* CSS animations */}
            <style>
                {`
                    @keyframes slideIn {
                        from {
                            transform: translateX(100%);
                            opacity: 0;
                        }
                        to {
                            transform: translateX(0);
                            opacity: 1;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default MenuAdvertisement;